var _a;
import { injected, metaMask, coinbaseWallet, walletConnect } from "@wagmi/connectors";
import { createConfig, http, fallback, webSocket } from "wagmi";
import { bsc } from "wagmi/chains";
var projectId = "".concat(process.env.REACT_APP_WALLETCONNECT_PROJECT_ID);
export var config = createConfig({
    // Это убирает авто-обнаружение (Keplr уйдет)
    multiInjectedProviderDiscovery: false,
    chains: [bsc],
    multiInjectedProviderDiscovery: false,
    connectors: [
        metaMask(),
        // Вот так теперь добавляется Trust Wallet
        injected({
            target: 'trustWallet'
        }),
        coinbaseWallet({ appName: "Wallet App" }),
        walletConnect({
            projectId: projectId,
            showQrModal: true,
        }),
    ],
    transports: (_a = {},
        _a[bsc.id] = fallback([
            webSocket("wss://bsc-rpc.publicnode.com"),
            http()
        ]),
        _a),
});
